const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

function isLoopbackHost(hostname) {
  return LOOPBACK_HOSTS.has(hostname);
}

function publicFacingFallback(configuredValue, fallbackValue) {
  if(!configuredValue) {
    return fallbackValue;
  }

  if(typeof window === 'undefined' || isLoopbackHost(window.location.hostname)) {
    return configuredValue;
  }

  try {
    const configuredUrl = new URL(configuredValue, window.location.origin);
    if(isLoopbackHost(configuredUrl.hostname)) {
      return fallbackValue;
    }
  }
  catch (_err) {
    return fallbackValue;
  }

  return configuredValue;
}

export const API_BASE_URL = publicFacingFallback(process.env.REACT_APP_API_BASE_URL, '');
export const KEYCLOAK_URL = publicFacingFallback(process.env.REACT_APP_KEYCLOAK_URL, '/auth');
